import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  Button,
  ButtonGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import CircularProgress from "@material-ui/core/CircularProgress";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Webcam from "react-webcam";
import { useTranslation } from "react-i18next";
import firebase from "../store/Firestore";
import { Context } from "../store/GlobalStore";
import moment from "moment";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import axios from "axios";

interface Props {}

interface FormData {
  createdDate: string;
  headingDirection: string;
  location: number[];
  modifiedDate: string;
  name: string | null;
  revisionDate: string;
  street: string;
  type: string | null;
}

const initFormData = {
  createdDate: moment().toISOString(),
  headingDirection: "",
  location: [],
  modifiedDate: moment().toISOString(),
  name: "Danger curve - right",
  revisionDate: moment().toISOString(),
  street: "",
  type: "",
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    subHeader: {
      marginTop: "10px",
      width: "100%",
      textAlign: "left",
    },
    input: {
      margin: "10px 0px",
    },
    label: {
      width: "100%",
      textAlign: "left",
    },
    img: {
      marginTop: "10px",
    },
    wrapper: {
      width: "100%",
    },
    buttonProgress: {
      color: theme.palette.primary.main,
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12,
    },
  })
);

export const Camera = (props: Props) => {
  const { store, dispatch } = useContext(Context);
  const { t } = useTranslation();
  const classes = useStyles();
  const [image, setImage] = useState<any>(null);
  const [formData, setFormData] = useState<FormData>(initFormData);
  const [automatic, setAutomatic] = useState<boolean>(true);
  const [camera, setCamera] = useState<any>({
    facingMode: { exact: "environment" },
  });
  const [signTypes, setSignTypes] = useState<any>();
  const [signNames, setSignNames] = useState<any>();

  const [loading, setLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);

  console.log(open);

  const handleCloseAdd = () => {
    console.log("add");
    setOpen(false);
    window.location.href = "/Camera";
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseMap = () => {
    console.log("map");
    setOpen(false);
    window.location.href = "/Map";
  };

  const resetLocation = () => {
    dispatch({
      type: "RESET_LOCATION",
      lat: store.lat,
      lng: store.lng,
    });
  };

  useEffect(() => {
    const db = firebase.firestore();

    const signRef = db.collection("signTypes");
    const sNames = db.collection("signImages");

    signRef.onSnapshot({ includeMetadataChanges: false }, function (snapshot) {
      let a: any = [];
      snapshot.forEach(function (childSnapshot) {
        a.push({
          id: childSnapshot.id,
          name: childSnapshot.data().name,
        });
      });
      setSignTypes(a);
    });

    sNames.onSnapshot({ includeMetadataChanges: false }, function (snapshot) {
      let a: any = [];
      snapshot.forEach(function (childSnapshot) {
        a.push({
          id: childSnapshot.id,
          name: childSnapshot.data().name,
        });
      });
      setSignNames(a);
    });
  }, []);

  const getClass = async (img: any): Promise<string> => {
    try {
      let formData = new FormData();
      formData.append("file", dataURItoBlob(img));
      const r = await axios.post(
        "https://fastapi-tmjbfwwnaq-ew.a.run.app/signs/classify",
        //"http://localhost:8000/signs/classify",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return r?.data?.className;
    } catch (e) {
      return "";
    }
  };

  const dataURItoBlob = (dataURI: any) => {
    var binary = atob(dataURI.split(",")[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
  };
  const getPosition = function () {
    console.log("here");
    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  };

  const postData = async (e: Event) => {
    try {
      const data = (await getPosition()) as any;
      let location = [];
      if (store.lng === 0 || store.lng === 0) {
        //if there are saved coordinates from clicked put sign there otherwise put it where the user is
        location.push(data.coords.latitude);
        location.push(data.coords.longitude);
      } else {
        location.push(store.lat);
        location.push(store.lng);
        resetLocation(); //resets saved location
      }

      const db = firebase.firestore();
      const userRef = db.collection("sign").add({
        ...formData,
        location: new firebase.firestore.GeoPoint(location[0], location[1]),
      });
      setOpen(true);
    } catch (e) {
      alert("Something went terribly wrong :(");
      console.log(e);
    }
  };

  const toggleCamera = () => {
    if (Object.keys(camera).length === 0)
      setCamera({ facingMode: { exact: "environment" } });
    else setCamera({});
  };

  //camera settings
  const webcamRef = React.useRef<Webcam>(null);

  const capture = React.useCallback(async () => {
    if (webcamRef.current) {
      setLoading(true);
      const img = webcamRef.current.getScreenshot();
      const imageClass = await getClass(img);
      console.log(imageClass);
      setFormData({ ...formData, name: imageClass });
      setImage(img);
      setLoading(false);
    }
  }, [webcamRef]);

  const header = (
    <>
      <Typography variant="h4" component="h4">
        {t("Add sign")}
      </Typography>
      <ButtonGroup color="primary" aria-label="outlined primary button group">
        <Button onClick={() => setAutomatic(true)}>{t("Capture")}</Button>
        <Button onClick={() => setAutomatic(false)}>{t("Manually")}</Button>
      </ButtonGroup>
    </>
  );

  //components

  const captureButton = (
    <div className={classes.wrapper}>
      <Button
        fullWidth
        variant="contained"
        color="primary"
        disabled={loading}
        onClick={capture}
      >
        {t("Capture")}
      </Button>
      {loading && (
        <CircularProgress size={24} className={classes.buttonProgress} />
      )}
    </div>
  );

  const startForm = (
    <>
      <Typography className={classes.subHeader}>
        {t("captureSignDesc")}
      </Typography>
      <Webcam
        audio={false}
        ref={webcamRef}
        width="90%"
        height="90%"
        screenshotFormat="image/jpeg"
        videoConstraints={camera}
      />
      <Button onClick={() => toggleCamera()} fullWidth>
        {t("Switch camera")}
      </Button>

      {captureButton}
    </>
  );

  const middleState = (
    <>
      <img src={image} alt="" className={classes.img} />
      {captureButton}
    </>
  );

  const endForm = (
    <>
      <img src={image} alt="" className={classes.img} />
      <Typography className={classes.subHeader}>{t("fillFormDesc")}</Typography>
      <Autocomplete
        className={classes.input}
        style={{ width: "100%" }}
        options={signNames}
        getOptionLabel={(option: any) => {
          if (option.name) {
            return option.name;
          } else {
            return option;
          }
        }}
        value={formData.name || ""}
        inputValue={formData.name || ""}
        onChange={(event: any, newValue: string | null) => {
          setFormData({ ...formData, name: newValue });
        }}
        onInputChange={(event: any, newInputValue: string) => {
          setFormData({ ...formData, name: newInputValue });
        }}
        renderInput={(params) => (
          <TextField {...params} label={t("Sign name")} />
        )}
      />

      <TextField
        className={classes.input}
        fullWidth
        id="outlined-helperText"
        label={t("Street")}
        placeholder="Main street"
        onChange={(e: any) => {
          setFormData({ ...formData, street: e.target.value });
        }}
      />

      <Autocomplete
        className={classes.input}
        style={{ width: "100%" }}
        options={signTypes}
        getOptionLabel={(option: any) => {
          if (option.name) {
            return option.name;
          } else {
            return option;
          }
        }}
        value={formData.type || ""}
        inputValue={formData.type || ""}
        onChange={(event: any, newValue: string | null) => {
          setFormData({ ...formData, type: newValue });
        }}
        onInputChange={(event: any, newInputValue: string) => {
          setFormData({ ...formData, type: newInputValue });
        }}
        renderInput={(params) => <TextField {...params} label="Sign type" />}
      />
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={(e: any) => postData(e)}
      >
        {t("Add sign")}
      </Button>
    </>
  );

  const dialog = (
    <Dialog
      open={open}
      onClose={() => handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{t("addedSignTitle")}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t("addedSignDesc")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseAdd} color="primary">
          {t("add another")}
        </Button>
        <Button onClick={handleCloseMap} color="primary" autoFocus>
          {t("show on map")}
        </Button>
      </DialogActions>
    </Dialog>
  );

  if (automatic) {
    return (
      <React.Fragment>
        <Box
          justifyContent="center"
          display="flex"
          flexDirection="column"
          alignItems="center"
          padding="5px 20px"
        >
          {header}

          {image === null && !loading ? startForm : ""}
          {image !== null && loading ? middleState : ""}
          {image !== null && !loading ? endForm : ""}
        </Box>
        {dialog}
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Box
          justifyContent="center"
          display="flex"
          flexDirection="column"
          alignItems="center"
          padding="5px 20px"
        >
          {header}
          <Typography className={classes.subHeader}>
            {t("manuallyFillFormDesc")}
          </Typography>

          <Autocomplete
            className={classes.input}
            style={{ width: "100%" }}
            options={signNames}
            getOptionLabel={(option: any) => {
              if (option.name) {
                return option.name;
              } else {
                return option;
              }
            }}
            value={formData.name || ""}
            inputValue={formData.name || ""}
            onChange={(event: any, newValue: string | null) => {
              setFormData({ ...formData, name: newValue });
            }}
            onInputChange={(event: any, newInputValue: string) => {
              setFormData({ ...formData, name: newInputValue });
            }}
            renderInput={(params) => (
              <TextField {...params} label={t("Sign name")} />
            )}
          />
          <TextField
            className={classes.input}
            fullWidth
            id="outlined-helperText"
            label={t("Street")}
            placeholder="Main street"
            onChange={(e: any) => {
              setFormData({ ...formData, street: e.target.value });
            }}
          />
          <Autocomplete
            className={classes.input}
            style={{ width: "100%" }}
            options={signTypes}
            getOptionLabel={(option: any) => {
              if (option.name) {
                return option.name;
              } else {
                return option;
              }
            }}
            value={formData.type || ""}
            inputValue={formData.type || ""}
            onChange={(event: any, newValue: string | null) => {
              setFormData({ ...formData, type: newValue });
            }}
            onInputChange={(event: any, newInputValue: string) => {
              setFormData({ ...formData, type: newInputValue });
            }}
            renderInput={(params) => (
              <TextField {...params} label="Sign type" />
            )}
          />
          {store.lat != 0 && store.lng != 0 ? ( //just to show location if it was clicked on map
            <p className={classes.input}>
              Clicked lat:{store.lat} lng:{store.lng}
            </p>
          ) : null}
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={(e: any) => postData(e)}
          >
            {t("Add sign")}
          </Button>
        </Box>
        {dialog}
      </React.Fragment>
    );
  }
};
